import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";
import style from "./TransactionStatusSkeleton.module.css";

export const TransactionStatusSkeleton = () => {
  return (
    <div className={style.skeletonContainer}>
      <SkeletonLoader width={12} height={12} variant="circular" />
      <SkeletonLoader width={80} height={8} variant="rectangular" />
      <SkeletonLoader width={80} height={16} variant="rectangular" />
    </div>
  );
};
